import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import Uppy from '@uppy/core';
import AWS from 'aws-sdk';
import OSS from 'ali-oss';//= require('ali-oss')
import AwsS3Multipart from '@uppy/aws-s3-multipart';
import Webcam from '@uppy/webcam';
import { DragDrop, Dashboard, DashboardModal, UppyContainer, StatusBar } from '@uppy/react';
// import { getLocalQueryString } from '../../../utils/common';
import Chinese from './zh'; //'@uppy/locales/lib/zh_CN';
import '@uppy/core/dist/style.css';
import '@uppy/status-bar/dist/style.css';
import '@uppy/drag-drop/dist/style.css';
import '@uppy/progress-bar/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import '@uppy/webcam/dist/style.css';
import '@uppy/url/dist/style.css';
import './index.scss';
let uppy = null,
	globalAwss3Token = {},
	localaws = null;
function fnAWS() {
	if (!localaws) {
		AWS.config.update({
			region: globalAwss3Token.bucket,
			credentials: new AWS.CognitoIdentityCredentials({
				IdentityPoolId: 'www'
			})
		});
		console.log ( "globalAwss3Token" , globalAwss3Token);
		globalAwss3Token.endpoint = globalAwss3Token.bucket+"."+globalAwss3Token.endpoint;
		localaws = new AWS.S3({
			...globalAwss3Token,
			apiVersion: '2020-03-16',
			s3BucketEndpoint: true
		});
	}
	return localaws;
}
function Vh5UppyUpload(props = {}) {
	let { awss3Token, showUppy, setShowUppy = () => {}, successCallback = () => {}, uploadType = '0' } = props;
	globalAwss3Token = awss3Token;
	useEffect(() => {
		if (uppy) {
			return;
		}
		uppy = Uppy({
			// meta: { type: 'avatar' },
			restrictions: {
				maxNumberOfFiles: 9,
				minNumberOfFiles: 1
				// allowedFileTypes: ['image/*', 'video/*']
			},
			autoProceed: false, //cache file , 点击开始上传 ( true )， 或者等会上传( false )
			debug: false,
			locale: Chinese,
			setFileMeta: (fileID, data) => {
				console.log('setFileMeta', fileID, data);
			},
			onBeforeFileAdded: (currentFile, files) => {
				const modifiedFile = Object.assign({}, currentFile, {
					lastname: currentFile.name + Date.now()
				});
				console.log('currentFile', currentFile);
				// console.log ( "modifiedFile" , currentFile ,modifiedFile);
				if (!currentFile.type) {
					uppy.log(`Skipping file because it has no type`);
					// show error message to the user
					uppy.info(`该文件类型不支持`, 'error', 5000);
					return false;
				}
				if (uploadType === '1' && Object.getOwnPropertyNames(files).length > 0) {
					uppy.info(`视频文件只能上传一个`, 'error', 5000);
					return false;
				}
				if (uploadType === '0' && !['image/jpeg', 'image/heic'].includes(currentFile.type)) {
					console.log('uploadType', uploadType, currentFile.type);
					uppy.info(`该文件类型不支持${currentFile.type}`, 'error', 5000);
					return false;
				} else if (uploadType === '1' && !['video/mp4', 'video/mov', 'video/quicktime'].includes(currentFile.type)) {
					uppy.info(`该文件类型不支持${currentFile.type}`, 'error', 5000);
					return false;
				}
				return modifiedFile;
			},
			onBeforeUpload: files => {
				console.log(files);
				const updatedFiles = {};
				Object.keys(files).forEach(fileID => {
					console.log('uploadid', fileID, 'key', files[fileID].name);
					updatedFiles[fileID] = {
						...files[fileID],
						name: 'www' + new Date().getTime() + '__' + files[fileID].name
					};
				});
				console.log('updatedFiles', updatedFiles);
				return updatedFiles;
			}
		});
		uppy.use(AwsS3Multipart, {
			limit: 3,
			timeout: 1000 * 60,
			chunkSize: 1024 * 20,
			companionUrl:globalAwss3Token.endpoint,// aliyun 才需要
			createMultipartUpload: function(file) {
				console.log ("globalAwss3Token.bucket + '/' + globalAwss3Token.uploadPath + file.name" , globalAwss3Token.bucket + '--/--' + globalAwss3Token.uploadPath + file.name);
				return new Promise(resolve => {
					fnAWS().createMultipartUpload(
						{
							Bucket: globalAwss3Token.bucket,
							// Key: globalAwss3Token.bucket + '/' + globalAwss3Token.uploadPath + file.name 
							Key: globalAwss3Token.uploadPath + file.name 
						},
						(error, data) => {
							resolve({
								uploadId: data.UploadId,
								key: data.Key
							});
						}
					);
				});
			},
			prepareUploadPart: function(file, partData) {
				return new Promise(resolve => {
					fnAWS().getSignedUrl(
						'uploadPart',
						{
							//uploadPart
							Bucket: globalAwss3Token.bucket, //'copyrightupload',
							// Key: globalAwss3Token.bucket + '/' + partData.key, //"copyrightupload/"+partData.key,
							Key: partData.key, //"copyrightupload/"+partData.key,
							UploadId: partData.uploadId,
							PartNumber: partData.number,
							Body: '', // Empty, because it is uploaded later
							Expires: 5 * 60
						},
						(err, url) => {
							let url2 = url.substring(0, url.indexOf('?')) + '?partNumber=' + partData.number + '&uploadId=' + partData.uploadId;
							console.log('url2', url2);
							let req = fnAWS().uploadPart({
								Bucket: 'copyrightupload',
								// Key: globalAwss3Token.bucket + '/' + partData.key,
								Key: partData.key,
								UploadId: partData.uploadId,
								PartNumber: partData.number,
								Body: partData.body
							});
							req.build(() => {
								let headers = req.httpRequest.headers;
								console.log('headers', headers);
								// delete headers['ETag'];
								// delete headers['Content-Length'];
								// delete headers['Host'];
								resolve({ url: url2 , headers });
								// resolve({ url: url2, headers });
							});
						}
					);
				});
			},
			completeMultipartUpload(file, { uploadId, key, parts }) {
				return new Promise(resolve => {
					var params = {
						Bucket: globalAwss3Token.bucket,
						// Key: globalAwss3Token.bucket + '/' + key,
						Key: key,
						MultipartUpload: {
							Parts: parts
						},
						UploadId: uploadId
					};
					fnAWS().completeMultipartUpload(params, function(err, data) {
						if (err) {
							console.log(err, err.stack); // an error occurred
						} else {
							console.log('complete', data);
							// resolve({ location: 'https://' + globalAwss3Token.endpoint + '/' + globalAwss3Token.bucket + '/' + key });
							resolve({ location: 'https://' + globalAwss3Token.endpoint + '/' + key });
						}
					});
				});
			}
		});
		uppy.use(Webcam, {
			onBeforeSnapshot: () => Promise.resolve(),
			countdown: false,
			title: '开启摄像头',
			modes: ['video-audio', 'video-only', 'audio-only', 'picture'],
			mirror: true,
			facingMode: 'user'
		});
		uppy.on('complete', (result, args) => {
			// const url = result.successful[0].uploadURL;
			// console.log('result', result , args , uppy.store.state.files);
			let firstid = result.successful[0].id;
			console.log(firstid);
			// uppy.removeFile(firstid);
			console.log('getFiles...', uppy.getFiles(), result.successful);
			// uppy.reset();
			// alert(result.successful.length);
			// setShowUppy(false , result.successful);
			successCallback(uppy.getFiles(), result.successful, uppy);
		});
		uppy.on('file-added', file => {
			Object.assign(file, { path: 'aulas' });
			console.log('file add...', file);
		});
		uppy.on('file-removed', file => {
			console.log('Removed file', file);
		});
		uppy.on('upload-progress', (file, progress) => {
			// file: { id, name, type, ... }
			// progress: { uploader, bytesUploaded, bytesTotal }
			console.log(file.id, progress.bytesUploaded, progress.bytesTotal);
		});
		uppy.on('upload-success', (file, response) => {
			console.log(file.name, response.uploadURL);
			// var img = new Image()
			// img.width = 300
			// img.alt = file.id
			// img.src = response.uploadURL
			// document.body.appendChild(img)
		});
	});
	console.log('uppy', uppy);
	return (
		<div className="v-uppy-upload">
			{uppy ? (
				<DashboardModal
					inline={false}
					uppy={uppy}
					open={showUppy}
					locale={{
						strings: {
							poweredBy: '版权图库上传',
							poweredByUppy: 'VPhoto',
							noDuplicates: '无法添加重复的文件“%{fileName}”，它已经存在'
						}
					}}
					plugins={['Webcam']}
					metaFields={[
						{ id: 'name', name: '文件名', placeholder: '文件名称' },
						{ id: 'caption', name: '描述', placeholder: '请填写图片描述' }
					]}
					trigger={'#J_btn'}
					closeModalOnClickOutside={true}
					onRequestClose={data => {
						console.log(data);
						setShowUppy(false);
					}}
					replaceTargetContent={true}
					showProgressDetails={true}
					note={uploadType === '0' ? '上传图片' : '上传视频'}
					saveFileCard={(meta, fileID) => {
						console.log('meta, fileID', meta, fileID);
					}}
				/>
			) : (
				''
			)}
		</div>
	);
}
export { Vh5UppyUpload };
